import { render, staticRenderFns } from "./CarousselSlide.vue?vue&type=template&id=06d9965c&"
import script from "./CarousselSlide.vue?vue&type=script&lang=js&"
export * from "./CarousselSlide.vue?vue&type=script&lang=js&"
import style0 from "./CarousselSlide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports